export const UPDATE_STORAGE_EVENT = 'onStoreUpdated';
